import { cva } from 'cva';

export const dialogPopup = cva({
  base: 'group shadow-xl focus:outline-hidden transition-all flex flex-col bg-surface-2 data-nested:border has-data-drag-active:border-primary-10 has-data-drag-active:bg-primary-2 has-data-drag-active:ring-2 has-data-drag-active:ring-primary-10 has-data-drag-active:shadow-primary/10',
  variants: {
    variant: {
      default: [
        'md:max-h-[80svh] max-h-[94svh] duration-200 p-3 pt-1 data-ending-style:scale-98 data-starting-style:scale-98 data-ending-style:opacity-0 data-starting-style:opacity-0',
        'md:-mt-6 -translate-x-1/2 -translate-y-1/2 fixed top-1/2 left-1/2 max-w-[calc(100vw-2.5rem)] will-change-transform',
      ],
      sidebar:
        'fixed top-2 left-2 bottom-2 duration-450 ease-smooth data-starting-style:-translate-x-[110%] data-ending-style:-translate-x-[110%]',
    },
    size: {
      xs: 'w-76 rounded-lg',
      sm: 'w-100 rounded-lg',
      md: 'w-120 rounded-lg',
      lg: 'w-150 rounded-lg',
      xl: 'w-180 rounded-lg',
      '2xl': 'w-210 rounded-xl **:data-[slot=dialog-content]:rounded-lg',
      '3xl': 'w-232 rounded-xl **:data-[slot=dialog-content]:rounded-lg',
      '4xl': 'w-284 rounded-xl **:data-[slot=dialog-content]:rounded-lg',
      stepper: 'w-268 md:rounded-xl max-md:max-w-full max-md:max-h-full max-md:h-full pt-3',
      viewport: 'md:mt-0 mt-0 h-svh max-h-svh md:max-h-svh w-full max-w-full data-nested:border-0',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'md',
  },
  compoundVariants: [
    {
      variant: 'sidebar',
      className: 'w-fit',
    },
  ],
});
